import React, { Component } from 'react';
import { connect } from 'react-redux';
import {FormattedMessage} from "react-intl";


class AlertContainer extends Component {
	constructor(props) {
		super(props)
		this.localStorageUpdated = this.localStorageUpdated.bind(this)
		this.state = {
			validationResponse: {}
		}
	}
	componentDidMount() {
		if (typeof window !== 'undefined') {
			this.setState({validationResponse: {}})

			window.addEventListener('storage', this.localStorageUpdated)
		}
	}
	componentWillUnmount(){
		if (typeof window !== 'undefined') {
			window.removeEventListener('storage', this.localStorageUpdated)
		}
	}

	localStorageUpdated(){
		if (!localStorage.getItem('validationResponse')) {
			this.updateState(false)
		}
		else  {
			this.updateState(localStorage.getItem('validationResponse'))
		}
	}
	updateState(value){
		this.setState({validationResponse:JSON.parse(value)})

		if(this.state.validationResponse.status){ //reinitialize state
			setTimeout(function(){
				this.setState({validationResponse:{}})
			}.bind(this),5000);
		}
	}

	render () {
			switch (this.state.validationResponse.status) {
				case "OK":
					return(<div className="alert-wrapper valid">
						<div className="image"/>
						<div className="answer">
							<FormattedMessage defaultMessage="Entrada válida" id="screen.ok.ca"/>
							<FormattedMessage defaultMessage="Entrada válida" id="screen.ok.es"/>
							<FormattedMessage defaultMessage="Entrada válida" id="screen.ok.en"/>
						</div>
					</div>)
				case "KO":
					return(<div className="alert-wrapper invalid">
						<div className="image"/>
						<div className="answer">
							<FormattedMessage defaultMessage="Entrada no válida" id="screen.ko.ca"/>
							<FormattedMessage defaultMessage="Entrada no válida" id="screen.ko.es"/>
							<FormattedMessage defaultMessage="Entrada no válida" id="screen.ko.en"/>
						</div>
					</div>)
				default:
					return(<div className="alert-wrapper none">
						<div className="image"/>
						<div className="answer">
							<FormattedMessage defaultMessage="Selecciona un validador" id="screen.none.ca"/>
							<FormattedMessage defaultMessage="Selecciona un validador" id="screen.none.es"/>
							<FormattedMessage defaultMessage="Selecciona un validador" id="screen.none.en"/>
						</div>
					</div>)
			}
	}
}


export default connect()(AlertContainer);
